// Ported from apps/{dmc,to}/src/utils/roomKeyGenerator.js (byte-identical in
// both apps). `generateRoomKey` and `parseKeyParams` (US-061 — needed by
// matchRoomSelection.ts) move here. The rest of that file
// (`findRoomByKey`/`findRoomsByKeys`/`areRoomsSame`) is used by
// booking/checkout screens outside the Trip Designer, out of this PRD's
// scope, so the app-local file stays and keeps exporting those, and
// `parseKeyParams` too since deleting it would break that file's imports.
//
// Generates a stable, unique key for a room selection so it can be matched
// across different API calls.

function tagsKey(tags: any[] | undefined) {
  return tags
    ?.map((t) => t.label?.toLowerCase()?.replace(/ /g, ''))
    ?.sort()
    ?.join('#');
}

function getPromotionsKey(promos: string[] = []) {
  const sorted = promos
    .map((promotion) => promotion.toLowerCase().replace(/\s+/g, ''))
    .sort();
  return JSON.stringify(sorted);
}

export function generateRoomKey(
  room: any,
  depth = 0,
  bedId: string | null = null,
) {
  const firstBed = room?.bedChoices?.[0];

  if (!firstBed) return null;

  const selectedBed =
    room.bedChoices.find((b: any) => b.id === bedId) ?? firstBed;
  const supplierCode = room.supplierCode || room.supplier;
  const tags = tagsKey(selectedBed.tags);
  const promotions = getPromotionsKey(selectedBed.promotions);
  // A specific delimiter ([bed:...]) encapsulates the bed ID because its
  // format is not uniform across suppliers.
  return `${room.name}_${supplierCode}_${room.source}_${selectedBed.totalPriceWithPromo}_${depth}_${tags}_${promotions}[bed:${selectedBed.id}]`;
}

export function parseKeyParams(key: string): {
  bedId: string | null;
  depth: number;
} {
  const bedId = key.match(/\[bed:(.+?)\]$/)?.[1] ?? null;
  const depth = parseInt(key.split('_')[4], 10);

  return { bedId, depth };
}
